import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, halfWidth } from "../../blocks/layout/columnSpans";

/**
 * Communication Audit as page config. A log entry written by the service, so the
 * page is read-only and its names link to the records they belong to.
 */
export const communicationAuditPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "g4c_communicationaudit",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          // A card that fills the row, so it matches the sidebar's height.
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-details",
              title: "Details",
              fields: [
                {
                  id: "field-g4c_auditdate",
                  type: "datetime",
                  name: "g4c_auditdate",
                  label: "Date",
                  span: halfWidth,
                },
                {
                  id: "field-g4c_page",
                  type: "text",
                  name: "g4c_page",
                  label: "Page",
                  span: halfWidth,
                },
                {
                  id: "field-g4c_contactidname",
                  type: "text",
                  name: "g4c_contactidname",
                  label: "Contact",
                  span: halfWidth,
                  link: { to: "/contact", idKey: "g4c_contactid" },
                },
                {
                  id: "field-g4c_additionalinformation",
                  type: "text",
                  name: "g4c_additionalinformation",
                  label: "Additional Information",
                  span: halfWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-communication",
              title: "Communication",
              fields: [
                {
                  id: "field-g4c_communicationidname",
                  type: "text",
                  name: "g4c_communicationidname",
                  label: "Communication",
                  span: fullWidth,
                  link: {
                    to: "/email-communication",
                    idKey: "g4c_communicationid",
                  },
                },
                {
                  id: "field-g4c_communicationactivityname",
                  type: "text",
                  name: "g4c_communicationactivityname",
                  label: "Activity",
                  span: fullWidth,
                  link: {
                    to: "/communication-activity",
                    idKey: "g4c_communicationactivity",
                    // The activity's name is the communication's, shown just above.
                    text: "View activity",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
